import axios from 'axios';

import {
    BASE_URL
} from '../../config';

import  { ACTION_TYPES } from '../../config/constants';
import { loadingAction } from '../../components/loading/loading.action';

export const getConfigs = (cb = () => {}) => {
    return (dispatch) => {
        axios.get(`${BASE_URL}configs`)
            .then(function (response) {
                const payload = response.data;
                dispatch({
                    type: ACTION_TYPES.GET_CONFIGS,
                    configs: payload
                });
                cb();
            });
    }
};

export const updateConfig = (data,cb = () => {}) => {
    return (dispatch) => {
        axios.post(`${BASE_URL}configs`,data)
            .then(function (response) {
                const payload = response.data;
                dispatch({
                    type: ACTION_TYPES.SET_CONFIGS,
                    config: payload
                });
                cb();
            });
    }
};

export const getDispatch = (callback) => {
    return loadingAction((dispatch, cb) => {
        axios.get(`${BASE_URL}dispatch/example`,{
            timeout: 999999999999
        })
        .then((response) => {
                dispatch({
                    type: ACTION_TYPES.GET_DISPATCHING_DATA,
                    data: response.data
                })
                callback(null,response.data);
            })
        .catch((err) => {
            callback(err,null)
        })
        .finally(() => {
            cb()
        })
    });
};
